export default __webpack_public_path__ + "static/media/double-single-border-none.07ff4680.svg";